import { Button } from "../../ui/button";
import { Switch } from "../../ui/switch";
import { Input } from "../../ui/input";
import { Pencil, ChevronUp, ChevronDown } from "lucide-react";
import { formatMXN } from "../../../lib/whatsapp";

export const AlbumLineListItem = ({ line, attrById, idx, total, onEdit, onToggle, onMove, bulkMode, bulkPrice, onBulkPriceChange }) => {
  const label = (id) => attrById[id]?.label || "—";
  return (
    <div className="flex items-center justify-between border rounded-lg px-4 py-3 gap-3" data-testid={`album-line-row-${line.id}`}>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium truncate">
          {label(line.type_id)} · {label(line.size_id)} · {label(line.pages_id)} páginas · {label(line.cover_id)}
        </p>
        <p className="text-xs text-muted-foreground">{line.sku_key}</p>
      </div>

      {bulkMode ? (
        <Input
          type="number"
          className="w-28 h-8"
          value={bulkPrice}
          onChange={(e) => onBulkPriceChange(line.id, e.target.value)}
          data-testid={`album-line-bulk-price-${line.id}`}
        />
      ) : (
        <span className="text-sm font-semibold w-24 text-right" data-testid={`album-line-price-${line.id}`}>{formatMXN(line.price)}</span>
      )}

      <label className="flex items-center gap-1.5 text-xs"><Switch checked={line.active} onCheckedChange={(v) => onToggle(line.id, "active", v)} data-testid={`album-line-active-${line.id}`} /> Activa</label>
      <label className="flex items-center gap-1.5 text-xs"><Switch checked={line.archived} onCheckedChange={(v) => onToggle(line.id, "archived", v)} data-testid={`album-line-archived-${line.id}`} /> Archivada</label>

      <button type="button" data-testid={`album-line-up-${line.id}`} disabled={idx === 0} onClick={() => onMove(line.id, -1)} className="disabled:opacity-30"><ChevronUp size={14} /></button>
      <button type="button" data-testid={`album-line-down-${line.id}`} disabled={idx === total - 1} onClick={() => onMove(line.id, 1)} className="disabled:opacity-30"><ChevronDown size={14} /></button>

      <Button size="sm" variant="outline" onClick={() => onEdit(line)} data-testid={`album-line-edit-${line.id}`}><Pencil size={14} /></Button>
    </div>
  );
};
